import AuthenticatedRoute from '../../components/Routes/AuthenticatedRoute';
import { ROUTES } from '../../routing';
import PreviewDashboard from '../../pages/Dashboard/PreviewDashboard';
import PreviewActivity from '../../pages/Activity/PreviewActivity';
import PreviewProject from '../../pages/Project/PreviewProject';
import PreviewProjectsDashboard from '../../pages/ProjectsDashboard/PreviewProjectsDashboard';

export const PREVIEW_CONTENT_ROUTES = [
  <AuthenticatedRoute
    exact
    path={ROUTES.PREVIEW.MODULE_DASHBOARD.PATH}
    key={ROUTES.PREVIEW.MODULE_DASHBOARD.PATH}
  >
    <PreviewDashboard />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PREVIEW.ACTIVITY.PATH}
    key={ROUTES.PREVIEW.ACTIVITY.PATH}
  >
    <PreviewActivity />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PREVIEW.PROJECT.PATH}
    key={ROUTES.PREVIEW.PROJECT.PATH}
  >
    <PreviewProject />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PREVIEW.PROJECTS_DASHBOARD.PATH}
    key={ROUTES.PREVIEW.PROJECTS_DASHBOARD.PATH}
  >
    <PreviewProjectsDashboard />
  </AuthenticatedRoute>,
];
